import { atom } from "recoil";
import { Prospect } from "../../types/prospect";

export const signedInUserAtom = atom<Prospect | null>({
  key: "signedInUserAtom",
  default: null,
});
